module.exports = __webpack_public_path__ + "static/media/s-b-vonlanthen-308747-unsplash.8fbcef03.jpg";